import { Injectable, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule, CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { HomeComponent } from './home.component';
import { AuthGuard, CanDeactivateGuard } from '../core/security';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UnsavedHomeChangesGuard implements CanDeactivate<HomeComponent> 
{
  // prompt user if leaving home tab without saving changes
  canDeactivate(
    component: HomeComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
    ): Observable<boolean|UrlTree>|Promise<boolean|UrlTree>|boolean|UrlTree {
      return !component.hasUnsavedData()
    }  
  
}

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard],
    canDeactivate:[CanDeactivateGuard] 
  }
];

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [UnsavedHomeChangesGuard]
})
export class HomeRoutingModule {}
